import { render, staticRenderFns } from "./WellnessReport.vue?vue&type=template&id=059f51fd&scoped=true&"
import script from "./WellnessReport.vue?vue&type=script&lang=js&"
export * from "./WellnessReport.vue?vue&type=script&lang=js&"
import style0 from "./WellnessReport.vue?vue&type=style&index=0&id=059f51fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f51fd",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox})
